import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import HomeView from '../views/huasTadeHomeView.vue'
import StrategiesView from '../views/StrategiesView.vue'
import HuasTrade from '../views/huasTrade.vue'

const routes = [
  
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/Strategies',
    name: 'Strategies',
    component: StrategiesView
  },
  {
    path: '/HuasTrade',
    name: 'HuasTrade',
    component: HuasTrade
  },
  {
    path: '/DataView',
    name: 'DataView',
    component: () => import('@/views/DataView')
  },
  {
    path: '/strategiesViewsContainer',
    name: 'strategiesViewsContainer',
    component: () => import('@/views/strategy_list_view/StrategiesViewsContainer')
  },
  {
    path: '/community',
    name: 'community',
    component: () => import('@/views/CommunityView')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/components/strat_board_highcharts/strat_grid_highchart')
  },
  {
    path: '/strategyDetails',
    name: 'strategyDetails',
    component: () => import('@/views/strategy_list_view/StrategyDetailsPage')
  },
  {
    path: '/strat_detail_amchart',
    name: 'strat_detail_amchart',
    component: () => import('@/components/strat_board_amcharts/strat_detail_amchart')
  },
  {
    path: '/strat_detail_amchart2',
    name: 'strat_detail_amchart2',
    component: () => import('@/components/strat_board_amcharts/strat_detail_amchart2')
  },
  {
    path: '/strategydetailsview',
    name: 'strategydetailsview',
    component: () => import('@/views/StrategyDetailsView')
  },
  {
    path: '/TestTable',
    name: 'TestTable',
    component: () => import('@/views/TestTable')
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
